import type { ICommand } from '@model-framework/command';
import type { IOrderRollback } from './IOrderRollback';
import type { DraggingElements } from './DraggingElements';
import type { DisplayOrderRepository } from '../infrastructure';

export class ChangeParentCommand implements ICommand {
  private orderRollback: IOrderRollback | undefined = undefined;

  constructor(
    private readonly draggingElements: DraggingElements,
    private readonly displayOrderRepository: DisplayOrderRepository
  ) {}

  do(): void {
    this.draggingElements.applyChangeParents(this.displayOrderRepository).then((rollback) => {
      this.orderRollback = rollback;
    });
  }

  undo(): void {
    if (!this.orderRollback) return;

    this.displayOrderRepository.rollback(this.orderRollback).then(() => {
      this.orderRollback = undefined;
    });
  }

  redo(): void {
    return this.do();
  }

  async canUndo(): Promise<boolean> {
    return !!this.orderRollback;
  }

  async canRedo(): Promise<boolean> {
    return !this.orderRollback;
  }
}
